import './App.css';

import React, { 
    FC, ReactNode 
 } from 'react'

interface Props {
    onClick?() : void,
    children?: ReactNode
}

export const Page: FC<Props> = ({
    onClick,
    children
}: Props)  => (
    <div className='Page' onClick={onClick}
    >
      {children}
    </div>
)
